import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-popper',
  templateUrl: './info-popper.component.html',
  styleUrls: ['./info-popper.component.scss'],
})
export class InfoPopperComponent implements OnInit {
  @Input() icon: string;
  @Input() popperAppendTo: string;

  ngOnInit(): void {}
}
